import { httpInstanceCommerce } from '@/services/httpInstance';

const postTapToPhoneService = async (dataSent: any) => {
  const endpoint = 'tap-to-phone/v1/phos-commerce';

  try {
    const response = await httpInstanceCommerce.post(endpoint, dataSent, {
      headers: { 'Content-Type': 'application/json' }
    });

    return response.data;
  } catch (error: any) {
    console.error('❌ Error en postTapToPhoneService:', {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return error?.response;
  }
};

export default postTapToPhoneService;
